"use client"

import { useState } from "react"
import { Card, Button, Avatar, Typography } from "antd"
import TrainerPopover from "./trainer_popover_menu"
import ico_more from "../../../../assets/images/ico_more.png"

const { Text, Link } = Typography

const TrainerCard = (props) => {
  const { data, seq, onTrainerDeleted, onTrainerUpdated, refreshData, ...rest } = props
  const [open, setOpen] = useState(false)
  const [getIsValid, setValid] = useState()
  const [getDelete, setDelete] = useState()

  const changeValid = (value) => {
    const newIsValid = props.data.is_valid == 0 ? 3 : 0
    props.data.is_valid = newIsValid
    setValid(value)

    // 부모 컴포넌트의 상태도 업데이트
    if (onTrainerUpdated) {
      onTrainerUpdated(data.account_id, { is_valid: newIsValid })
    }
  }

  const changeDelete = (value) => {
    setDelete(value)

    // 부모 컴포넌트에서 해당 트레이너를 목록에서 제거
    if (onTrainerDeleted) {
      onTrainerDeleted(data.account_id)
    }
  }

  // 스타일 코드는 동일하므로 생략...
  const styles = {
    container: {
      display: "flex",
      width: "100%",
      height: "40rem",
      flexDirection: "column",
      alignItems: "flex-start",
      padding: 0,
      margin: 0,
      fontFamily: "Public Sans",
      fontStyle: "normal",
    },
    header: {
      display: "flex",
      width: "100%",
      height: "4.8rem",
      justifyContent: "flex-end",
      padding: 0,
      margin: 0,
    },
    avatar: {
      display: "flex",
      width: "100%",
      height: "10rem",
      justifyContent: "center",
      padding: 0,
      margin: 0,
    },
    name: {
      display: "flex",
      width: "100%",
      justifyContent: "center",
      padding: 0,
      margin: 0,
      fontWeight: 600,
      fontSize: "2.2rem",
      lineHeight: "3rem",
    },
    role: {
      display: "flex",
      width: "100%",
      justifyContent: "center",
      padding: 0,
      margin: 0,
      fontWeight: 600,
      fontSize: "1.5rem",
      lineHeight: "2.2rem",
      color: "#5C576A",
    },
    row: {
      display: "flex",
      width: "100%",
      justifyContent: "center",
    },
    column: {
      display: "flex",
      width: "4.6rem",
      flexDirection: "column",
      justifyContent: "center",
    },
    count: {
      display: "flex",
      width: "100%",
      justifyContent: "center",
      fontWeight: 600,
      fontSize: "2.2rem",
      lineHeight: "3rem",
    },
    sType: {
      display: "flex",
      width: "100%",
      justifyContent: "center",
      fontWeight: 400,
      fontSize: "1.5rem",
      lineHeight: "2.2rem",
      color: "#5C576A",
    },
  }

  const accountId = data.account_id
  const adminName = data.account_name
  const centerName = data.center_name
  const isValid = data.is_valid == 3 ? "F" : "T"

  return (
    <Card title={null} bordered={false}>
      <div style={{ ...styles.container }}>
        <div style={{ ...styles.header }}>
          <TrainerPopover
            {...props}
            accountId={accountId}
            adminName={adminName}
            centerName={centerName}
            isValid={isValid}
            width={30}
            component={<img width={22} height={22} src={ico_more || "/placeholder.svg"} />}
            changeValid={changeValid}
            changeDelete={changeDelete}
            // 데이터 갱신 함수들 전달
            onTrainerDeleted={onTrainerDeleted}
            onTrainerUpdated={onTrainerUpdated}
            refreshData={refreshData}
          />
        </div>

        {/* 프로필 섹션 */}
        <div style={{ ...styles.avatar }}>
          <Avatar
            size={100}
            src={
              data.photo_path && data.photo_key && data.photo_ext
                ? `https://cdn.humanb.kr/${data.photo_path}/${data.photo_key}.${data.photo_ext}`
                : require("../../../../assets/images/avatar_default.png")
            }
          />
        </div>
        <div style={{ ...styles.name, marginTop: 30 }}>{data.account_name}</div>
        <div style={{ ...styles.role }}>{"트레이너"}</div>

        {/* 통계 섹션 */}
        <div style={{ ...styles.row, marginTop: 30 }}>
          <div
            style={{
              ...styles.row,
              width: "20rem",
              justifyContent: "space-between",
            }}
          >
            <div style={{ ...styles.column }}>
              <div style={{ ...styles.count }}>{data.sequence_count}</div>
              <div style={{ ...styles.sType }}>{`시퀀스`}</div>
            </div>
            <div style={{ ...styles.column }}>
              <div style={{ ...styles.count }}>{data.tempo_count}</div>
              <div style={{ ...styles.sType }}>{`템포`}</div>
            </div>
            <div style={{ ...styles.column }}>
              <div style={{ ...styles.count }}>{data.lecture_count}</div>
              <div style={{ ...styles.sType }}>{`강좌`}</div>
            </div>
          </div>
        </div>

        {/* 상태 버튼 */}
        <div style={{ ...styles.row, marginTop: 30 }}>
          <Button
            icon={
              <img
                style={{ marginLeft: "0rem" }}
                width={18}
                height={18}
                src={require("../../../../assets/images/ico_user_check.png") || "/placeholder.svg"}
              />
            }
            onClick={(e) => {
              // accountId={accountId}
            }}
            style={{
              display: "flex",
              width: "20.9rem",
              height: "3.8rem",
              alignItems: "center",
              justifyContent: "space-between",
              flexDirection: "row",
              border: 0,
              background: `#7367F0`,
              marginRight: "1rem",
              boxShadow: "0px 2px 4px rgba(165, 163, 174, 0.3)",
              borderRadius: 6,
            }}
          >
            <Text
              style={{
                width: "100%",
                color: "#FFF",
                alignItem: "center",
              }}
            >
              {props.data.is_valid == 3 ? `앱 사용 권한 비활성 상태` : `앱 사용 권한 활성 상태`}
            </Text>
          </Button>
        </div>
      </div>
    </Card>
  )
}

export default TrainerCard
